<template>
  <va-card>
    <div class="row col-12 d-flex justify--space-between">
      <h5 class="is-bold">{{ measurementTitle }}</h5>
      <font-awesome-icon
        icon="fa-solid fa-down-left-and-up-right-to-center"
        class="clickable card-icon"
        @click.prevent="$emit('collapse')"
      />
    </div>
    <div class="row col-12">
      <div class="col-md-3 col-sm-3" v-if="!hideMaxAvgMin">
        <va-card class="d-flex align-items-center text-center" style="min-height: 170px; height: 100%">
          <p class="mb-0"><span class="is-bold">{{ $t('dashboard_new_evollu.parameters.titles.max_value') }}:</span></p>
          <p class="mb-0" v-for="(value, name) in statsData">
            <span>{{ $t(`dashboard_new_evollu.measurement_types.${name}_short`) }}: {{ statsData[name].max }}</span></p>
          <p class="mb-0"><span class="is-bold">{{ $t('dashboard_new_evollu.parameters.titles.medium_value') }}: </span>
          </p>
          <p class="mb-0" v-for="(value, name) in statsData">
            <span>{{ $t(`dashboard_new_evollu.measurement_types.${name}_short`) }}: {{ statsData[name].avg }}</span></p>
          <p class="mb-0"><span class="is-bold">{{
              $t('dashboard_new_evollu.parameters.titles.minimum_value')
            }}: </span></p>
          <p class="mb-0" v-for="(value, name) in statsData">
            <span>{{ $t(`dashboard_new_evollu.measurement_types.${name}_short`) }}: {{ statsData[name].min }}</span></p>
        </va-card>
      </div>
      <div class="col-3 col-md-3 col-sm-3 mt-5" v-if="hideMaxAvgMin">
        <div class="mb-3 icon-last-measurement">
          <div class="row col-12 d-flex align-content-center">
            <div class="col-3" style="min-width: 72px">
              <span :class="icon"/>
            </div>
            <div class="col-9">
              <span class="is-bold"> {{ $t('checkup_plus.measurements.last_measurement') }}:  </span>
              <span>{{data[0].last_chart_result}}</span>
            </div>
          </div>

          <div class="text-center">
            <label style="font-size: 12.5px"
                   :class="{'recent-update': hasBeenUpdatedRecently}">{{ $t('dashboard_new_evollu.titles.last_update') }}: {{ lastUpdate || "N/A" }} </label>
          </div>
        </div>

      </div>

      <!--<div :class="{'col-md-9': !hideMaxAvgMin, 'col-sm-9': !hideMaxAvgMin, 'col-md-12': hideMaxAvgMin, 'col-sm-12': hideMaxAvgMin}">-->
      <div class="col-9 col-md-9">
        <div>
          <va-tabs v-model="tabValue" style="border-width: 2px">
            <va-tab
              v-for="tab in viewType"
              :key="tab"
            >
              {{ $t(`dashboard_new_evollu.parameters.titles.${tab}`) }}
            </va-tab>
          </va-tabs>

          <div class="row">
            <v-client-table
              class="w-100"
              v-if="tabValue === 0"
              id="dataTable"
              ref="dataTable"
              name="dataTable"
              :data="data"
              :columns="actionsAddedToColumns"
              :options="tableOptions"
              @row-click="handleShowProfileModal"
            >
              <span slot="created_at" slot-scope="{row}">
                {{ row.created_at }}
              </span>
              <span slot="automatic" slot-scope="{row}">
                <va-popover
                  v-if="row.automatic !== null && row.automatic === true"
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submitted_by.device')">
                  <i class="fa fa-tablet"/>
                </va-popover>
                <va-popover
                  v-else
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submitted_by.manual')">
                  <i class="fa fa-pencil"/>
                </va-popover>
              </span>
              <!-- ---------------------------------- -->
              <!-- SPECIFIC FOR OPTOMETRY MEASUREMENT -->
              <!-- ---------------------------------- -->
              <!-- Chromatic Correct -->
              <div slot="chromatic_correct" slot-scope="{row}" class="text-center">
                {{`${row.chromatic_correct}/${parseInt(row.chromatic_correct) + parseInt(row.chromatic_wrong)}`}}
              </div>
              <!-- Chromatic Correct -->

              <div slot="h__astigmatism" style="text-align: center !important;">
                {{$t('optometry.leads.astigmatism')}}
              </div>
              <div slot="h__contrast" style="text-align: center !important;">
                {{$t('optometry.leads.contrast')}}
              </div>
              <div slot="h__macular" style="text-align: center !important;">
                {{$t('optometry.leads.macular')}}
              </div>
              <div slot="h__acuity" style="text-align: center !important;">
                {{$t('optometry.leads.acuity')}}
              </div>

              <div slot="astigmatism" slot-scope="{row}" class="text-center">
                <div class="col-12"><span class="is-bold"> {{$t('clinical.appointments.hearing_devices.left_abreviatture')}}: </span> <span>{{row.astigmatism_left}}</span></div>
                <div class="col-12"><span class="is-bold"> {{$t('clinical.appointments.hearing_devices.right_abreviatture')}}: </span><span>{{row.astigmatism_right}}</span></div>

              </div>

              <div slot="contrast" slot-scope="{row}" class="text-center">
                <div class="col-12"><span class="is-bold"> {{$t('clinical.appointments.hearing_devices.left_abreviatture')}}: </span> <span>{{row.contrast_left}}</span></div>
                <div class="col-12"><span class="is-bold"> {{$t('clinical.appointments.hearing_devices.right_abreviatture')}}: </span><span>{{row.contrast_right}}</span></div>
              </div>

              <div slot="macular" slot-scope="{row}" class="text-center">
                <div class="col-12"><span class="is-bold"> {{$t('clinical.appointments.hearing_devices.left_abreviatture')}}: </span> <span>{{row.macular_left}}</span></div>
                <div class="col-12"><span class="is-bold"> {{$t('clinical.appointments.hearing_devices.right_abreviatture')}}: </span><span>{{row.macular_right}}</span></div>
              </div>

              <div slot="acuity" slot-scope="{row}" class="text-center">
                <div class="col-12"><span class="is-bold"> {{$t('clinical.appointments.hearing_devices.left_abreviatture')}}: </span> <span>{{row.acuity_left}}</span></div>
                <div class="col-12"><span class="is-bold"> {{$t('clinical.appointments.hearing_devices.right_abreviatture')}}: </span><span>{{row.acuity_right}}</span></div>
              </div>

              <div slot="duochrome" slot-scope="{row}" class="text-center">
                <i class="fa fa-check" v-if="row.duochrome === $t('clinical.labels.yes')"></i>
                <i class="fa fa-times" v-else></i>
              </div>

              <!-- ---------------------------------- -->
              <!-- SPECIFIC FOR OPTOMETRY MEASUREMENT -->
              <!-- ---------------------------------- -->

              <div slot="actions" slot-scope="{row}" class="text-center">
                <va-popover :message="$t('dashboard_new_evollu.measurements.delete_measurement')" placement="left"
                            v-if="canDeleteMeasurement">
                  <i class="fa fa-times-circle p-2" @click.prevent.stop="onClickDeleteMeasurement(row)"></i>
                </va-popover>
              </div>
            </v-client-table>

            <div v-if="tabValue===1" style="min-width: 100%">
              <div  v-if="graphData.datasets.length && graphData.datasets.length > 0">
                <!--<va-chart class="chart" :data="graphData" :options="chartOptions" type="line"/>-->
                <apexchart type="line" :series="graphData.datasets" :options="chartOptions" height="500" width="100%"/>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <ConfirmationModal
      v-if="isDeletingMeasurement"
      :title="$t('dashboard_new_evollu.measurements.delete_measurement')"
      :body="$t('dashboard_new_evollu.measurements.modal_delete_measurement', {created: selectedMeasurementToDelete.created_at})"
      okClass="btn-danger"
      @modal-confirmed="onConfirmDeleteMeasurement"
      @modal-canceled="onCancelDeleteMeasurement"
    >
    </ConfirmationModal>

    <ProfileModal
      v-if="showProfileModal"
      :measurement="selectedMeasurement"
      :patientDetails="patientDetails"
      :measurementTitle="measurementTitle"
      @cancel="onCancelProfileModal">
    </ProfileModal>
  </va-card>
</template>

<script>
import {ClientTable} from 'vue-tables-2'
import Vue from "vue";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import ProfileModal from "@/components/checkup_plus/patients/ParametersDetails/ProfileModal.vue";
import {OneCareService} from "@/api/OneCareService";
import moment from "moment";

Vue.use(ClientTable, {}, false, 'bootstrap4')
export default {
  name: "TableAndGraph",
  components: {
    ClientTable,
    ConfirmationModal,
    ProfileModal,
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    graphOptions: {
      required: false,
    },
    graphData: {
      required: true,
      type: Object
    },
    statsData: {
      required: true,
      type: Object
    },
    hideMaxAvgMin: {
      type: Boolean,
      default: false,
      required: false
    },
    canDeleteMeasurement: {type: Boolean, default: false, required: true},
    allowShowProfileModal: {
      type: Boolean,
      default: false,
    },
    patientDetails: {
      type: Object,
      required: false
    },
    measurementTitle: {
      type: String,
      required: true
    },
    lastUpdate: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
  },
  data: function () {
    return {
      tabValue: 0,
      showProfileModal: false,
      tableOptions: {
        sortable: [],
        filterable: false,
        headings: {
          created_at: this.$t('tables.columns.created_at'),
          notes: this.$t('dashboard_new_evollu.parameters.titles.notes'),
          systolic: this.$t('dashboard_new_evollu.measurement_types.systolic_short'),
          diastolic: this.$t('dashboard_new_evollu.measurement_types.diastolic_short'),
          heart_rate: this.$t('dashboard_new_evollu.measurement_types.heart_rate_short'),
          duration_session: this.$t('dashboard_new_evollu.measurement_types.duration_session_short'),
          oximetry_max: this.$t('dashboard_new_evollu.measurement_types.oximetry_max_short'),
          oximetry_min: this.$t('dashboard_new_evollu.measurement_types.oximetry_min_short'),
          oximetry_avg: this.$t('dashboard_new_evollu.measurement_types.oximetry_avg_short'),
          pulse_rate_max: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_max_short'),
          pulse_rate_min: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_min_short'),
          pulse_rate_avg: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_avg_short'),
          body_temperature: this.$t('dashboard_new_evollu.measurement_types.body_temperature'),
          forced_expiratory_volume_6_sec: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_6_sec_short'),
          forced_expiratory_volume_1_sec: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_1_sec_short'),
          fev1_fev6: this.$t('dashboard_new_evollu.measurement_types.fev1_fev6_short'),
          forced_mid_expiratory_flow_25_75: this.$t('dashboard_new_evollu.measurement_types.forced_mid_expiratory_flow_25_75_short'),
          body_weight: this.$t('dashboard_new_evollu.measurement_types.body_weight_short'),
          body_mass_index: this.$t('dashboard_new_evollu.measurement_types.body_mass_index_short'),
          body_water_percentage: this.$t('dashboard_new_evollu.measurement_types.body_water_percentage_short'),
          body_fat_percentage: this.$t('dashboard_new_evollu.measurement_types.body_fat_percentage_short'),
          body_muscle_mass: this.$t('dashboard_new_evollu.measurement_types.body_muscle_mass_short'),
          frailty_accessment_result: this.$t('dashboard_new_evollu.measurement_types.frailty_accessment_result_short'),
          frailty_exhaustion_result: this.$t('dashboard_new_evollu.measurement_types.frailty_exhaustion_result_short'),
          frailty_physical_activity: this.$t('dashboard_new_evollu.measurement_types.frailty_physical_activity_short'),
          frailty_walk_time: this.$t('dashboard_new_evollu.measurement_types.frailty_walk_time_short'),
          frailty_dominant_strength: this.$t('dashboard_new_evollu.measurement_types.frailty_dominant_strength_short'),
          frailty_weight_loss: this.$t('dashboard_new_evollu.measurement_types.frailty_weight_loss_short'),
          sarc_f: this.$t('dashboard_new_evollu.measurement_types.sarc_f_short'),
          hand_grip: this.$t('dashboard_new_evollu.measurement_types.hand_grip_short'),
          gait_speed: this.$t('dashboard_new_evollu.measurement_types.gait_speed_short'),
          sarc_result: this.$t('dashboard_new_evollu.measurement_types.sarc_result_short'),
          fasting: this.$t('dashboard_new_evollu.measurement_types.fasting_short'),
          blood_glucose: this.$t('dashboard_new_evollu.measurement_types.blood_glucose_short'),
          actions: this.$t('tables.columns.actions'),
          cholesterol_total: this.$t('dashboard_new_evollu.measurement_types.cholesterol_total'),
          hdl_cholesterol: this.$t('dashboard_new_evollu.measurement_types.hdl_cholesterol'),
          ldl_cholesterol: this.$t('dashboard_new_evollu.measurement_types.ldl_cholesterol'),
          triglycerides: this.$t('dashboard_new_evollu.measurement_types.triglycerides'),
          automatic: this.$t('checkup_plus.person.measurements.automatic'),
          optometry_result: this.$t('dashboard_new_evollu.measurement_types.optometry_result_short'),
          astigmatism: this.$t('optometry.leads.astigmatism'),
          duochrome: this.$t('optometry.leads.duochrome_test_results'),
          chromatic_correct: this.$t('optometry.leads.chromatic_correct_answers'),
          contrast: this.$t('optometry.leads.contrast'),
          macular: this.$t('optometry.leads.macular'),
          acuity: this.$t('optometry.leads.acuity')
        },
        skin: 'table table-striped table-hover is-fullwidth',
        perPage: 5,
        perPageValues: [5, 10, 15, 20, 30, 50, 100],
        pagination: {
          chunk: 5,
          nav: 'scroll'
        },
        columnsClasses: {
          actions: 'actions',
          automatic: 'actions',
          created_at: 'created-at',
          astigmatism: 'min-width-140',
          contrast: 'min-width-140',
          macular: 'min-width-140',
          acuity: 'min-width-140'
        }
      },
      isDeletingMeasurement: false,
      selectedMeasurementToDelete: null,
      selectedMeasurement: null
    }
  },
  created() {

  },
  computed: {
    viewType: function () {
      if(Object.keys(this.graphData).length === 0) {
        return ['table']
      }
      return ['table', 'graph']
    },
    hasBeenUpdatedRecently: function () {
      if (this.lastUpdate !== null) {
        return moment().diff(moment(this.lastUpdate), 'hours') < 12
      }
      return false
    },
    chartOptions: function () {
      let categories = []
      if(this.graphData) {
        categories = this.graphData.labels
      }
      return {
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 50,
          animateGradually: {
            enabled: false,
            delay: 50
          },
          dynamicAnimation: {
            enabled: true,
            speed: 50
          }
        },
        theme: {
          palette: 'palette1'
        },
        xaxis: {
          categories: categories
        },
      }
    },
    actionsAddedToColumns: function () {
      if (!this.columns.includes('actions')) {
        this.columns.push('actions')
      }
      return this.columns
    }
  },
  methods: {
    handleShowProfileModal: function ({row}) {
      if (this.allowShowProfileModal && row.measurementSeries !== null && row.measurementSeries.length > 0) {
        this.selectedMeasurement = row
        this.showProfileModal = true
      } else {
        this.showToast(this.$t('dashboard_new_evollu.measurements.no_profile'), this.$store.state.errorToastOptions)
      }
    },
    onCancelProfileModal: function () {
      this.selectedMeasurement = null
      this.showProfileModal = false
    },
    onClickDeleteMeasurement: function (measurement) {
      this.isDeletingMeasurement = true
      this.selectedMeasurementToDelete = measurement
    },
    onConfirmDeleteMeasurement: function () {
      OneCareService.deleteMeasurement(this.selectedMeasurementToDelete.id)
        .then(response => {
          this.showToast(this.$t('dashboard_new_evollu.measurements.successful_delete'), this.$store.state.successToastOptions)
          this.$emit('update_measurement', this.selectedMeasurementToDelete.measurementTypeId)
          this.onCancelDeleteMeasurement()
        })
        .catch(errors => {
          this.showToast(this.$t('dashboard_new_evollu.measurements.something_went_wrong'), this.$store.state.errorToastOptions)
          console.error(errors)
        })
    },
    onCancelDeleteMeasurement: function () {
      this.isDeletingMeasurement = false
      this.selectedMeasurementToDelete = null
    },
  }
}
</script>
<style scoped lang="scss">

.icon-last-measurement {
  height: 80%;
  display: flex;
  flex-direction: column;
}

.card-icon {
  color: $vue-green;
  font-size: 22px;
}
</style>
<style lang="scss">
.actions {
  text-align: center;
}
.created-at {
  min-width: 160px;
}

.min-width-140 {
  min-width: 140px
}
</style>
